import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validacion',
  templateUrl: './validacion.component.html',
  styleUrls: ['./validacion.component.css']
})
export class ValidacionComponent implements OnInit {

  showDetalle:boolean;
  showApelacion:boolean;

  constructor() { }

  ngOnInit(): void {
    this.showDetalle=false;
    this.showApelacion=false;
  }

}
